import { TIconProps } from './utils';

export const MenuMobIcon = ({ className = '' }: TIconProps) => (
  <svg
    className={className}
    width='45'
    height='45'
    viewBox='0 0 45 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='11.25'
      y='14.75'
      width='23.5'
      height='0.5'
      fill='white'
      stroke='white'
      strokeWidth='0.5'
    />
    <rect
      x='11.25'
      y='20.75'
      width='23.5'
      height='0.5'
      fill='white'
      stroke='white'
      strokeWidth='0.5'
    />
    <rect
      x='11.25'
      y='26.75'
      width='23.5'
      height='0.5'
      fill='white'
      stroke='white'
      strokeWidth='0.5'
    />
  </svg>
);
